// Need to use the React-specific entry point to import createApi
import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'

const BASE_URL = '/';

// Messages api
// we generate markup for messages in wordpress and this return the markup to be displayed
export const chatbotApi = createApi({
  reducerPath: 'chatbotApi',
  baseQuery: fetchBaseQuery({ baseUrl: BASE_URL }),
  endpoints: (builder) => ({

    // access token is the Auth0 access token
    sendMessage: builder.query({
      query ({userQuestion, accessToken, tokenId, isAdmin}) {
          return {
              url: "chatbot",
              headers: {
                  'Content-Type': 'application/json',
              },
              method: 'POST',
              body: {question: userQuestion, accessToken: accessToken ? accessToken : null, tokenId: tokenId ? tokenId : null, context: "website", isAdmin: isAdmin}
          }
      
      }
  }),

  // Flag a response as a bad resonse
  flagBadResponse: builder.query({
    query ({chatHistoryId, badResponse}) {
        return {
            url: "badResponse/" + chatHistoryId,
            headers: {
                'Content-Type': 'application/json',
            },
            method: 'PUT',
            body: {badResponse: badResponse}
        }
    
    }
}),

// grab previous chat session history
loadChatHistory: builder.query({
    query ({identifier, limit, offset}) {
        return {
            url: "history/" + identifier + "/" + limit + "/" + offset,
            headers: {
                'Content-Type': 'application/json',
            },
            method: 'GET',
        }
    
    }
}),

// check if there is chat history to load - attempts to just pull one record
checkForChatHistory: builder.query({
    query ({identifier, offset}) {
        return {
            url: "history/" + identifier + "/" + 1 + "/" + offset,
            headers: {
                'Content-Type': 'application/json',
            },
            method: 'GET',
        }
    
    }
}),
}),
})

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const { useLazySendMessageQuery, useLazyAddVectorQuery, useLazyFlagBadResponseQuery, useLazyLoadChatHistoryQuery, useLazyCheckForChatHistoryQuery} = chatbotApi